import React from 'react';
import moment from 'moment';
import { LATEST_RELEASE, OLDER_RELEASE } from '@utils/constants';
import { ReleaseDate } from './styled';

// Get date in DD MMM format
function ReleaseTagDate({ currentKey, data, versionData }) {
  const getReleaseDate = (indexVal) => {
    const getDate = moment(versionData[indexVal].newVersion.releaseDate).format('MMM DD');
    return getDate;
  };
  /**
   * Return a range of date which is lesser than the latest release
   * Api sends sorted data by data
   * Range will be shown as title header to separate rows
   * Method gets the count by first release date to calculate remaining
   * */
  const getOtherDateRange = () => {
    const keys = Object.keys(versionData);
    const lastKey = keys[keys.length - 1];
    const firstItem = versionData[0].newVersion.releaseDate;
    const findList = Object.values(versionData)
      .map((value) => value.newVersion.releaseDate)
      .filter((currentRelease) => currentRelease === firstItem).length;
    if (currentKey === Number(findList)) {
      return (
        <ReleaseDate>
          {' '}
          {OLDER_RELEASE} ({getReleaseDate(findList)} - {getReleaseDate(lastKey)})
        </ReleaseDate>
      );
    }
  };

  return (
    <div>
      {currentKey === 0 ? (
        <ReleaseDate>
          {' '}
          {LATEST_RELEASE} ({getReleaseDate(currentKey)})
        </ReleaseDate>
      ) : (
        ''
      )}
      {getOtherDateRange()}
    </div>
  );
}
export default ReleaseTagDate;
